import { lazy } from "react";
import { BiCategory, BiSolidBank } from "react-icons/bi";
import { BsChatLeftText } from "react-icons/bs";
import {
  FaCog,
  FaHome,
  FaQuestionCircle,
  FaUserCheck,
  FaUserFriends,
} from "react-icons/fa";
import { GrUserWorker } from "react-icons/gr";
import { IoMdPaper } from "react-icons/io";
import { IoNotificationsSharp, IoReturnDownBack } from "react-icons/io5";
import { LuFileCog } from "react-icons/lu";
import { RiSlideshow3Line } from "react-icons/ri";
import {
  TbCurrencyDollar,
  TbSpeakerphone,
  TbTransfer,
  TbTruckDelivery,
  TbUser,
} from "react-icons/tb";

const Dashboard = lazy(() => import("../pages/Dashboard"));
const Chat = lazy(() => import("../pages/Chat"));
// const AdsManagement = lazy(() => import("../pages/AdsManagement"));
// const AdsManagementDetails = lazy(() =>
// import("../pages/AdsManagementDetails")
// );
const UserManagement = lazy(() => import("../pages/UserManagement"));
const SignupRequests = lazy(() => import("../pages/SignupRequests"));
const PatientTransaction = lazy(() =>
  import("../pages/TransactionManagement/PatientTransaction")
);
const Notifications = lazy(() => import("../pages/Notifications"));
const ProfileSettings = lazy(() => import("../pages/ProfileSettings"));
const Login = lazy(() => import("../pages/Login"));
const Roles = lazy(() => import("../pages/Roles"));
const CategoryManagement = lazy(() => import("../pages/CategoryManagement"));
const AddDoctor = lazy(() => import("../pages/AddDoctor"));
const AddRole = lazy(() => import("../pages/AddRole"));
const EditRole = lazy(() => import("../pages/EditRole"));
const ViewDoctor = lazy(() => import("../pages/ViewDoctor"));
const EditDoctor = lazy(() => import("../pages/EditDoctor"));
const WithdrawalRequest = lazy(() =>
  import("../pages/TransactionManagement/WithdrawalRequest")
);
const Commission = lazy(() =>
  import("../pages/TransactionManagement/Commission")
);
const DeliverySettings = lazy(() =>
  import("../pages/TransactionManagement/DeliverySettings")
);
const CreatePharmacy = lazy(() => import("../pages/AddPharmacy"));
const EditPharmacy = lazy(() => import("../pages/EditPharmacy"));
const ViewPharmacy = lazy(() => import("../pages/ViewPharmacy"));
const AddPatient = lazy(() => import("../pages/AddPatient"));
const EditPatient = lazy(() => import("../pages/EditPatient"));
const ViewPatient = lazy(() => import("../pages/ViewPatient"));
const ViewShopkeeper = lazy(() => import("../pages/ViewShopkeeper"));
const CreateShopkeeper = lazy(() => import("../pages/AddShopkeeper"));
const EditShopkeeper = lazy(() => import("../pages/EditShopkeeper"));
const Support = lazy(() => import("../pages/Support"));

const BannerAd = lazy(() => import("../pages/Ads/Banner"));
const SliderAd = lazy(() => import("../pages/Ads/Slider"));

const Cms = lazy(() => import("../pages/Cms"));

export const routes = [
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    icon: <FaHome />,
    element: <Dashboard />,
  },
  {
    path: "/login",
    exact: true,
    protected: false,
    icon: <FaHome />,
    element: <Login />,
  },
  {
    path: "/user-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "User Management",
    icon: <FaUserFriends />,
    element: <UserManagement />,
    subMenu: [
      {
        path: "/user-management/signup-requests",
        exact: true,
        showInSidebar: true,
        title: "Signup Requests",
        icon: <FaUserCheck />,
        element: <SignupRequests />,
      },
    ],
  },
  {
    path: "/user-management/doctor/create",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <AddDoctor />,
  },
  {
    path: "/user-management/doctor/update/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <EditDoctor />,
  },
  {
    path: "/user-management/doctor/view/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <ViewDoctor />,
  },
  {
    path: "/user-management/patient/create",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <AddPatient />,
  },
  {
    path: "/user-management/patient/view/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <ViewPatient />,
  },
  {
    path: "/user-management/patient/update/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <EditPatient />,
  },
  {
    path: "/user-management/shopkeeper/create",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <CreateShopkeeper />,
  },
  {
    path: "/user-management/shopkeeper/view/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <ViewShopkeeper />,
  },
  {
    path: "/user-management/shopkeeper/update/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <EditShopkeeper />,
  },
  {
    path: "/user-management/pharmacy/create",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <CreatePharmacy />,
  },
  {
    path: "/user-management/pharmacy/update/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <EditPharmacy />,
  },
  {
    path: "/user-management/pharmacy/view/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Management",
    element: <ViewPharmacy />,
  },
  {
    showInSidebar: true,
    protected: true,
    title: "Transaction Management",
    icon: <TbTransfer />,
    subMenu: [
      {
        path: "/patient-transaction",
        exact: true,
        showInSidebar: true,
        title: "Patient Transaction",
        icon: <BiSolidBank />,
        element: <PatientTransaction />,
      },
      {
        path: "/withdrawal-requests",
        exact: true,
        showInSidebar: true,
        title: "Withdrawal Requests",
        icon: <IoReturnDownBack />,
        element: <WithdrawalRequest />,
      },
      {
        path: "/commission",
        exact: true,
        showInSidebar: true,
        title: "Commission",
        icon: <TbCurrencyDollar />,
        element: <Commission />,
      },
      {
        path: "/delivery-settings",
        exact: true,
        showInSidebar: true,
        title: "Delivery Settings",
        icon: <TbTruckDelivery />,
        element: <DeliverySettings />,
      },
    ],
  },
  {
    path: "/chat",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Chat & Support",
    icon: <BsChatLeftText />,
    element: <Chat />,
  },
  {
    path: "/roles",
    exact: true,
    protected: true,
    showInSidebar: true,
    icon: <GrUserWorker />,
    title: "Roles",
    element: <Roles />,
  },
  {
    path: "/category-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    icon: <BiCategory />,
    title: "Category Management",
    element: <CategoryManagement />,
  },
  {
    path: "/roles/add",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <AddRole />,
  },
  {
    path: "/roles/edit/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    element: <EditRole />,
  },
  {
    showInSidebar: true,
    protected: true,
    title: "Ads Management",
    icon: <TbSpeakerphone />,
    subMenu: [
      {
        path: "/banner-ad",
        exact: true,
        showInSidebar: true,
        title: "Banner Ad",
        icon: <IoMdPaper />,
        element: <BannerAd />,
      },
      {
        path: "/slider-ad",
        exact: true,
        showInSidebar: true,
        title: "Slider Ad",
        icon: <RiSlideshow3Line />,
        element: <SliderAd />,
      },
    ],
  },
  // {
  //   path: "/ads-management",
  //   exact: true,
  //   protected: true,
  //   showInSidebar: true,
  //   title: "Ads Management",
  //   icon: <TbSpeakerphone />,
  //   element: <AdsManagement />,
  // },
  // {
  //   path: "/ads-management/:id",
  //   exact: true,
  //   protected: true,
  //   showInSidebar: false,
  //   title: "Ads Management",
  //   element: <AdsManagementDetails />,
  // },

  {
    path: "/profile-settings",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Profile Settings",
    icon: <TbUser />,
    element: <ProfileSettings />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Notifications",
    icon: <IoNotificationsSharp />,
    element: <Notifications />,
  },
  {
    path: "/support",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Support",
    icon: <FaQuestionCircle />,
    element: <Support />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Cms",
    icon: <LuFileCog />,
    element: <Cms />,
  },
];
